"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _const = require("../const");

var _default = function _default(state, type, pos) {
  var dir = null;

  switch (pos) {
    case 'top':
    case 'bottom':
      dir = _const.DIRECTION_VERT;
      break;

    case 'left':
    case 'right':
      dir = _const.DIRECTION_HORZ;
      break;
  }

  if (!dir || !state[_const.TYPE_LOCKS][type]) {
    return false;
  }

  return state[_const.TYPE_LOCKS][type][dir];
};

exports["default"] = _default;